import { InfoVoucherAction } from "Pages/InfoVoucherPage/Redux/actions";

export interface IInfoVoucher {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Content.VoucherPage;
};

const initialInfoVoucher: IInfoVoucher = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoVoucher(
  state: IInfoVoucher = initialInfoVoucher, 
  action: InfoVoucherAction,
  ): IInfoVoucher {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_VOUCHER_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_VOUCHER_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_VOUCHER_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoVoucher;


// WEBPACK FOOTER //
// ./src/pages/InfoVoucherPage/Redux/reducer.tsx